import { gql } from "@apollo/client"
import { useMutation, InjectedOptions } from "@oysterhr/core"
import { CreateBacsCheckoutSessionInput, CreateBacsCheckoutSessionPayload } from "@oysterhr/schema"

const PAYMENTS_COMPANY_CREATE_BACS_CHECKOUT_SESSION = gql`
  mutation PaymentsCompanyCreateBacsCheckoutSession($companyId: ID!) {
    createBacsCheckoutSession(input: { companyId: $companyId }) {
      errors
      checkoutSession {
        sessionId
      }
    }
  }
`

const useCreateBacsCheckoutSession = (
  options?: InjectedOptions<
    { createBacsCheckoutSession: CreateBacsCheckoutSessionPayload },
    CreateBacsCheckoutSessionInput
  >,
) =>
  useMutation<
    { createBacsCheckoutSession: CreateBacsCheckoutSessionPayload },
    CreateBacsCheckoutSessionInput
  >(PAYMENTS_COMPANY_CREATE_BACS_CHECKOUT_SESSION, options)

export default () => {
  const [createBacsCheckoutSession] = useCreateBacsCheckoutSession()

  return { createBacsCheckoutSession }
}
